import { createI18n } from "vue-i18n";

const i18n = createI18n({
    locale: window.config?.locale ?? "de",
    fallbackLocale: "de",
    legacy: false,
    globalInjection: true,
    messages: {},
});

const localeModules = import.meta.glob("../Lang/*.json");

export async function loadLocale(locale) {
    if (!i18n.global.availableLocales.includes(locale)) {
        const module = await localeModules[`../Lang/${locale}.json`]();
        i18n.global.setLocaleMessage(locale, module.default);
    }
    i18n.global.locale.value = locale;
}

export default i18n;
